import { Admin, Resource, useTranslate } from "react-admin";
import { MyLayout } from "./Layout/MyLayout";
import { dataProvider } from "./Services/dataProvider";
import { i18nProvider } from './i18n/i18nProvider';
import Homepage from "./Page/homepage";
import { authProvider } from "./Services/authProvider";
import { MyTheme } from "./styles/MyTheme";
import React from "react";
import MyLoginPage from "./Page/MyLoginPage";


import { TrafficAccountList } from "./Page/trafficAccount/TrafficAccountList";
import { TrafficAccountCreate } from "./Page/trafficAccount/TrafficAccountCreate";

import { strategyCreate } from "./Page/strategy/strategyCreate";
import { strategyList } from "./Page/strategy/strategyList";
import { strategyEdit } from "./Page/strategy/strategyEdit";
import { deployList } from "./Page/deploy/deployList";
import { equipmentDetails } from "./Page/equipmentDetails/equipmentDetailsList";
import { trafficRevenue } from "./Page/trafficRevenue/trafficRevenueList";
import { DeviceAccountCreate } from "./Page/deviceAccount/DeviceAccountCreate";
import { DeviceAccountList } from "./Page/deviceAccount/DeviceAccountList";
import { EquipmentList } from "./Page/equipment/equipment";
import { deviceRevenueList } from "./Page/deviceRevenue/deviceRevenueList";
import { storeProductCreate } from "./Page/storeProduct/storeProductCreate";
import { storeProductList } from "./Page/storeProduct/storeProductList";
import { outboundProductList } from "./Page/outboundProduct/outboundProductList";
import { outboundProductCreate } from "./Page/outboundProduct/outboundProductCreate";
import { outboundProductBatchCreate } from "./Page/outboundProduct/outboundProductBatchCreate";

import { outboundQueryList } from "./Page/outboundQuery/outboundQueryList";
import { upgradeSystemCreate } from "./Page/upgradeSystem/upgradeSystemCreate";
import { upgradeSystemEdit } from "./Page/upgradeSystem/upgradeSystemEdit";
import { upgradeSystemList } from "./Page/upgradeSystem/upgradeSystemList";
import { factoryTestingList } from "./Page/factoryTesting/factoryTestingList";
import { factoryTestingCreate } from "./Page/factoryTesting/factoryTestingCreate";
import { MACAddressList } from "./Page/MACAddress/MACAddressList";
import { userManageCreate } from "./Page/userManage/userManageCreate";
import { userManageEdit } from "./Page/userManage/userManageEdit";
import { userManageList } from "./Page/userManage/userManageList";
import { ChangePassword } from "./Page/ChangePassword";
import { otaUpgradeList } from "./Page/otaUpgrade/otaUpgradeList";
import { QueryClient } from '@tanstack/react-query';
import { TrafficAccountEdit } from "./Page/trafficAccount/TrafficAccountEdit";
import { DeviceAccountEdit } from "./Page/deviceAccount/DeviceAccountEdit";
import { reconciliationList } from "./Page/reconciliation/reconciliationList";
import { withdrawalList } from "./Page/withdrawal/withdrawalList";
import { xunleiDeployList } from "./Page/xunleiDeploy/xunleiDeployList";
import { xunleiSnManageList } from "./Page/xunleiSnManage/xunleiSnManageList";
import { otaUpgradeDetails } from "./Page/otaUpgrade/otaUpgradeDetails";
import { trafficRevenueDetail } from "./Page/trafficRevenue/trafficRevenueDetail";
import { deviceRevenueDetail } from "./Page/deviceRevenue/deviceRevenueDetail";
import { withdrawalDetail } from "./Page/withdrawal/withdrawalDetail";
import outboundProductDetail from "./Page/outboundProduct/outboundProductDetail";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 60 * 1000, // 30分钟缓存
      refetchOnWindowFocus: false, // 切换标签页不重新请求
      retry: 1, // 只重试1次
      retryDelay: 1000,
    },
    mutations: {
      retry: false, // 修改操作不重试
    },
  },
});

export const App = () => {
  const translate = useTranslate();

  return (
    <React.Fragment>
      <Admin
        queryClient={queryClient}
        layout={MyLayout}
        dataProvider={dataProvider}
        authProvider={authProvider}
        loginPage={MyLoginPage}
        dashboard={Homepage}
        i18nProvider={i18nProvider}
        theme={MyTheme}>

        <Resource name="trafficAccount" create={TrafficAccountCreate} edit={TrafficAccountEdit} list={TrafficAccountList} options={{ label: translate('ra.sideMenu.trafficSales.addUser') }} />
        <Resource name="strategy" create={strategyCreate} edit={strategyEdit} list={strategyList} options={{ label: translate('ra.sideMenu.trafficSales.strategy') }} />
        <Resource name="deploy" list={deployList} options={{ label: translate('ra.sideMenu.trafficSales.deploy') }} />
        <Resource name="xunleiDeploy" list={xunleiDeployList} options={{ label: translate('ra.sideMenu.trafficSales.wxDeploy') }} />
        <Resource name="xunleiSnManage" list={xunleiSnManageList} options={{ label: translate('ra.sideMenu.trafficSales.wxSnManage') }} />
        <Resource
          name="trafficRevenue"
          list={trafficRevenue}
          show={trafficRevenueDetail}
          options={{ label: translate('ra.sideMenu.trafficSales.trafficRevenue') }}
        />

        <Resource name="equipmentDetails" list={equipmentDetails} options={{ label: translate('ra.sideMenu.trafficSales.equipmentDetails') }} />

        <Resource name="deviceAccount" create={DeviceAccountCreate} edit={DeviceAccountEdit} list={DeviceAccountList} options={{ label: translate('ra.sideMenu.equipmentSales.deviceAccount') }} />
        <Resource name="equipment" list={EquipmentList} options={{ label: translate('ra.sideMenu.equipmentSales.equipment') }} />
        <Resource name="deviceRevenue" show={deviceRevenueDetail} list={deviceRevenueList} options={{ label: translate('ra.sideMenu.equipmentSales.deviceRevenue') }} />


        <Resource name="reconciliation" list={reconciliationList} options={{ label: '财务管理' }} />
        <Resource name="withdrawal" list={withdrawalList} show={withdrawalDetail} options={{ label: '提现管理' }} />

        <Resource name="upgradeSystem" create={upgradeSystemCreate} edit={upgradeSystemEdit} list={upgradeSystemList} options={{ label: translate('ra.sideMenu.equipmentSales.upgradeSystem') }} />

        <Resource name="userManage" create={userManageCreate} edit={userManageEdit} list={userManageList} options={{ label: '用户管理' }} />
        <Resource name="storeProduct" create={storeProductCreate} list={storeProductList} options={{ label: translate('ra.sideMenu.factory.storeProduct') }} />

        <Resource name="outboundProduct/BatchCreate" list={outboundProductBatchCreate} options={{ label: '批量出库' }} />

        <Resource name="outboundProduct" list={outboundProductList} show={outboundProductDetail} create={outboundProductCreate} options={{ label: translate('ra.sideMenu.factory.outboundProduct') }} />
        <Resource name="outboundQueryList" list={outboundQueryList} options={{ label: translate('ra.sideMenu.factory.outboundQueryList') }} />
        <Resource name="factoryTesting" create={factoryTestingCreate} list={factoryTestingList} options={{ label: translate('ra.sideMenu.factory.factoryTesting') }} />
        <Resource name="otaUpgrade" list={otaUpgradeList} show={otaUpgradeDetails} options={{ label: translate('ra.sideMenu.equipmentSales.otaUpgrade') }} />

        <Resource name="MACAddress" list={MACAddressList} options={{ label: translate('ra.sideMenu.factory.MACAddress') }} />
        <Resource name="change-password" list={ChangePassword} />
      </Admin>
    </React.Fragment>
  );
}
